module.exports = __webpack_public_path__ + "static/media/31.ec6cce94.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/31.png
// module id = 992
// module chunks = 0